module.exports = __webpack_public_path__ + "static/media/ca_14.71e59269.png";